<template>
  <div id="app" :class="((theme=='dark')?'bg-dark theme-dark':'')">
    <div id="nav">
      <div>
        <router-link to="/">Главная</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/login">Вход</router-link>
        <router-link to="/reg">Регистрация</router-link>
      </div>
      <router-link to="/settings">Настройки</router-link>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    theme() {
      return this.$store.state.settings.theme;
    }
  }
}
</script>

<style src="bootstrap/dist/css/bootstrap.min.css" />
<style>
html {
  width: 100%;
  height: 100%;
}
body {
  width: 100%;
  min-height: 100%;
}

.theme-dark {
  color: #eee;
}

.content {
  margin: 0 20px 0 80px;
}
#app {
  min-height: 100%;
  width: 100%;
  position: absolute;
}

#nav {
  position: fixed;
  left: 0;
  top: 0;
  width: 80px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.theme-dark #nav a {
  color: #dfefff;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
#nav div {
  display: flex;
  flex-direction: column;
}
</style>
